// Vyhledat meta tag s názvem CNCUserPaid (def-head.twig)
export const isPayingUser = (): boolean => {
  const CNCUserPaid: HTMLMetaElement | null = document.querySelector('meta[name="CNCUserPaid"]');

  return CNCUserPaid ? true : false;
};
